module.exports = __webpack_public_path__ + "img/Pom_Blossom.f8e35c81.png";